type PhantomWindow = Window & {
  phantom?: {
    ethereum?: unknown
    solana?: unknown
  }
}

type NavigatorInfo = Pick<Navigator, 'maxTouchPoints' | 'userAgent'>

export const isMobileBrowser = (navigatorInfo: NavigatorInfo = navigator) => {
  const mobileUserAgent = /Android|iPad|iPhone|iPod/i.test(
    navigatorInfo.userAgent
  )
  const desktopModeIPad =
    /Macintosh/i.test(navigatorInfo.userAgent) &&
    navigatorInfo.maxTouchPoints > 1

  return mobileUserAgent || desktopModeIPad
}

export const isPhantomBrowser = (
  windowObject: PhantomWindow = window as PhantomWindow
) => Boolean(windowObject.phantom?.ethereum || windowObject.phantom?.solana)
